// SPDX-License-Identifier: MIT
// Copyright (c) 2022 The Pybricks Authors

import reducer from './redux';

export default reducer;
